import { StyledFileViewer } from "@components/fileViewers/FileViewers.styles";
import { StyledField } from "@components/inputs/field/Field.styles";
import { StyledLabel } from "@components/inputs/field/Label.styles";
import { getInputPadding, INPUT_MIN_HEIGHT } from "@components/inputs/input/Input.styles";
import Tabs from "@components/tabs";
import { TabWrapper } from "@components/tabs/Tabs.styles";
import styled from "styled-components";

import { T_HEADER_bold, T_PLAIN_big } from "../../../global.style";
import { VIEW_PADDING_VALUE } from "../../../views/View.styles";

export const TabsStyled = styled(Tabs)`
    ${TabWrapper} {
        margin-top: 40px;
        margin-bottom: 0;
    }
`;

export const DeductionsWrapper = styled.div`
    display: grid;
    grid-template-columns: max-content auto auto;
    column-gap: 20px;
    row-gap: 12px;
    
    ${StyledLabel} {
        min-height: ${INPUT_MIN_HEIGHT}px;
        margin: 0;
        align-items: center;
    }
    
    ${StyledField} {
        margin-right: 0 !important;
    }
`;

export const DeductionItem = styled.span`
    ${T_PLAIN_big};
    line-height: 1.2;
`;

export const LikeReadOnlyFieldButLowerAndAlignWithNonReadOnlyField = styled(DeductionItem)`
    text-align: right;
    padding: ${getInputPadding()};
    padding-top: 0;
    padding-bottom: 0;
`;

export const DetectedChangesSubtitle = styled.span`
    ${T_HEADER_bold};
    margin-top: 24px;
    display: block;
`;

export const DetectedChangeLine = styled.div`
    
`;

export const DaysLeftTextWrapper = styled.div`
    ${T_PLAIN_big};
    margin-bottom: 20px;
`;

export const EmployeePayslipContent = styled.div`
    padding: 30px 0;
`;

export const YearSelectorWrapper = styled.div`
    width: 180px;
`;


export const EmployeePayslipFileViewWrapperStyled = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    max-height: 100%;
    max-width: 100%;
    padding: ${VIEW_PADDING_VALUE}px;

    ${StyledFileViewer} {
        flex: 1 1 auto;
        height: 0;
    }
`;